import React, {useState} from 'react'
import './CustomerTabsRow.scss'
import PageComponent from './PageComponent'
import PropTypes from 'prop-types'
import ColumnsRow from './ColumnsRow'
import {get} from 'lodash'
import ReactMarkdown from 'react-markdown'
import {GatsbyImage} from 'gatsby-plugin-image'
import * as routes from '../../constants/routes'
import {graphql, useStaticQuery} from 'gatsby'
import {Link} from 'gatsby-plugin-react-i18next'
import {useTranslation} from 'react-i18next'
import cmsMarkdownRenderers from '../../helpers/markdown/cmsMarkdownRenderers'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight'

const CustomerTabsRow = ({title, tabs}) => {
    const {t} = useTranslation()
    const data = useStaticQuery(graphql`
        {
            allStrapiCustomer {
                edges {
                    node {
                        strapiId
                        logo {
                            image {
                                childImageSharp {
                                    gatsbyImageData(width: 300, placeholder: NONE, layout: CONSTRAINED)
                                }
                            }
                            alt
                        }
                    }
                }
            }
        }
    `)

    const tabsWithLogo = tabs.map((tab) => {
        const customer = data.allStrapiCustomer.edges.find((customer) => customer.node.strapiId === tab.customerId)
        return {
            ...tab,
            logoImageData: get(customer, 'node.logo.image.childImageSharp.gatsbyImageData', null),
            logoImageAlt: get(customer, 'node.logo.alt', null),
        }
    })

    const [currentItem, setCurrentItem] = useState(tabs[0])
    const [prevItem, setPrevItem] = useState(tabs[0])

    const setItem = (tab) => {
        setCurrentItem(tab)
        setPrevItem(tab)
    }

    return (
        <PageComponent backgroundColor={'lightgray'}>
            {!!title && <ReactMarkdown source={title} className={'mb-5'} />}
            <div className="customer-tabs-row__wrapper">
                <div className="customer-tabs-row__current">
                    <div className="customer-tabs-row__image">
                        <GatsbyImage
                            image={currentItem.imageData}
                            alt={currentItem.imageAlt}
                            objectFit="cover"
                            className={`background-image`}
                        />
                        <GatsbyImage
                            image={prevItem.imageData}
                            alt={prevItem.imageAlt}
                            objectFit="cover"
                            className={`front-image`}
                            style={{position: 'absolute', width: '100%'}}
                        />
                    </div>
                    <div className="customer-tabs-row__content">
                        <ReactMarkdown
                            source={currentItem.content}
                            className="customer-tabs-row__content-text"
                            escapeHtml={false}
                            renderers={cmsMarkdownRenderers}
                        />
                    </div>
                </div>
                <div className="customer-tabs-row__buttons">
                    {tabsWithLogo.map((tab) => (
                        <div
                            key={tab.id}
                            role="button"
                            tabIndex={0}
                            className={`customer-tabs-row__button ${tab.id === currentItem.id ? 'is-current' : ''}`}
                            onClick={() => setItem(tab)}
                            onKeyDown={() => setItem(tab)}
                        >
                            <GatsbyImage image={tab.logoImageData} alt={tab.logoImageAlt} style={{height: '100%'}} />
                        </div>
                    ))}
                    <Link
                        to={routes.CASESTUDIES}
                        id="ga__all-customers"
                        className="customer-tabs-row__button show-all"
                        role="button"
                        tabIndex={0}
                    >
                        <span>{t('customer-tabs-row_show-all')}</span>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </Link>
                </div>
            </div>
        </PageComponent>
    )
}

export default CustomerTabsRow

ColumnsRow.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            content: PropTypes.string,
            imageData: PropTypes.object,
            imageAlt: PropTypes.string,
            customerId: PropTypes.string,
        })
    ),
}

ColumnsRow.defaultProps = {
    tabs: [],
}
